module.exports = __webpack_public_path__ + "img/cloud-upload.6595e820.svg";